export default {
    unit_type_id: "Id",
    unit_type_name: "Name",
    unit_type_status: "Status",
    unit_type_add_new: "Add New",
    unit_type_events: "Events",
    unit_type_uses_sim: "Uses SIM",
    unit_type_use_imei_as_serial: "Use IMEI as Serial Number",
}